import { useEffect, useState } from "react"
import "../Styles/Component/ProductPreview.css"
import {AiOutlineStar, AiOutlineHeart, AiFillStar} from "react-icons/ai"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import Cookies from "js-cookie"


const ProductPreview = ({modal, onClose, data}) => {
    const [openModal, setOpenModal] = useState(modal)
    const [quantity, setQuantity] = useState(1)

    const navigate = useNavigate()

    useEffect(() => {
        setOpenModal(modal)
    }, [modal])

    const handleClose = () => {
        onClose()
        setOpenModal(modal)
    }

    const changeQuantity = (value) => {
        value === "reduce" ? setQuantity(quantity === 0 ? 0 : quantity - 1) : setQuantity(quantity + 1)
    }

    
  const addToCart = () => {
    if(!Cookies.get('TOKEN')){
        toast.error('Please login first')
        return
    }
    let cart = localStorage.getItem('cart');
    if (!cart) {
        cart = [];
    } else {
        cart = JSON.parse(cart);
    }
    const existingProduct = cart.find(item => item.id === data.id);

        if (existingProduct) {
            toast.error("Item already exists in cart")
            return
        } else {
        // If the product doesn't exist in the cart, add it
        cart.push({...data, qty: quantity});
        }
        localStorage.setItem('cart', JSON.stringify(cart));
        toast.success("Item added to cart successfully")
    }
    const addToWishlist = () => {
        if(!Cookies.get('TOKEN')){
        toast.error('Please login first')
        return
        }
        let wishlist = localStorage.getItem('wishlist');
        if (!wishlist) {
            wishlist = [];
        } else {
            // Parse the existing cart from a JSON string
            wishlist = JSON.parse(wishlist);
        }
        const existingProduct = wishlist.find(item => item.id === data.id);

        if (existingProduct) {
            toast.error("Item already exists in Wishlist")
            return
        } else {
        // If the product doesn't exist in the cart, add it
        wishlist.push({...data});
        }
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        toast.success("Item added to wishlist successfully")
    }
    
    const rating = (num) => {
        const rate = Math.round(num) || 0
        return rate === 5 ?
        <div className="rating">
            <AiFillStar/>
            <AiFillStar/>
            <AiFillStar/>
            <AiFillStar/>
            <AiFillStar/>
        </div> : 
        rate === 4 ? 
        <div className="rating">
            <AiFillStar/>
            <AiFillStar/>
            <AiFillStar/>
            <AiFillStar/>
            <AiOutlineStar/>

        </div> : 
        rate === 3 ? 
        <div className="rating">
            <AiFillStar/>
            <AiFillStar/>
            <AiFillStar/>
            <AiOutlineStar/>
            <AiOutlineStar/>

        </div> : 
        rate === 2 ? 
        <div className="rating">
            <AiFillStar/>
            <AiFillStar/>
            <AiOutlineStar/>
            <AiOutlineStar/>
            <AiOutlineStar/>

        </div> : 
        <div className="rating">
            <AiFillStar/>
            <AiOutlineStar/>
            <AiOutlineStar/>
            <AiOutlineStar/>
            <AiOutlineStar/>

        </div>
    }

    const description = (value) => {
        if(!value){
            return ""
        }
        const info = value.split(' ');
        const first20 = info.slice(0, 15);
        const description = first20.join(' ') + "..."
        return description
    }

    return<>
        <section className={openModal ? "productPreviewWrapper" : "hide"}>
            <div className="productPreview">
                <div className="close" onClick={handleClose}>x</div>
                <div className="leftPreview">
                    <img src={data.images && data.images[0].url} alt="" />
                    <div className="subImages">
                    {
                        data.images && data.images.map((el) => {
                            return(<img src={el.url} alt="" />)
                        })
                    }
                    </div>
                </div>
                <div className="rightPreview">
                    <div className="rating">
                        {rating(data.ratings)}
                        <p>( {data.ratings} rating)</p>
                    </div>
                    <h2>{data.name}</h2>
                    <h1>${data.discountPrice}</h1>
                    <p className="description">{description(data.description)}</p>
                    <div className="productWrap">
                        <p>Category:</p>
                        <span>{data.category}</span>
                    </div>

                    <div className="cartWrapper">
                        <div className="count">
                            <p className="reduce" onClick={() => changeQuantity("reduce")}>-</p>
                            <p>{quantity}</p>
                            <p className="add" onClick={() => changeQuantity("add")}>+</p>
                        </div>
                        <button onClick={addToCart}>Add to Cart</button>
                    </div>

                    <p className="wishlist" onClick={addToWishlist}> <AiOutlineHeart/> Add to wishlist</p>
                    <button className="view" onClick={() => navigate(`/product/${data.id}`)}>View Product</button>


                </div>
            </div>
        </section>

    </>

}

export default ProductPreview